module.exports = "https://cdn.thelire.com/ins/resource/picPaymentrConfirmaccount@3x.425585049143ac0d0f7c21500b31b5f6.png";